var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_462_10683)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 81,
    r: 60,
    fill: "#3B3D4B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.875 109.062H55.9062C54.862 109.062 53.8604 108.648 53.122 107.909C52.3836 107.171 51.9688 106.169 51.9688 105.125V63.7812C51.9688 62.737 52.3836 61.7354 53.122 60.997C53.8604 60.2586 54.862 59.8438 55.9062 59.8438H57.875C58.9193 59.8438 59.9208 60.2586 60.6592 60.997C61.3977 61.7354 61.8125 62.737 61.8125 63.7812V105.125C61.8125 106.169 61.3977 107.171 60.6592 107.909C59.9208 108.648 58.9193 109.062 57.875 109.062ZM79.5312 71.6562C79.5312 70.612 79.1164 69.6104 78.378 68.872C77.6396 68.1336 76.638 67.7188 75.5938 67.7188H67.7188C66.6745 67.7188 65.6729 68.1336 64.9345 68.872C64.1961 69.6104 63.7812 70.612 63.7812 71.6562V75.1016C63.7812 75.2321 63.8331 75.3573 63.9254 75.4496C64.0177 75.5419 64.1429 75.5938 64.2734 75.5938H79.0391C79.1696 75.5938 79.2948 75.5419 79.3871 75.4496C79.4794 75.3573 79.5312 75.2321 79.5312 75.1016V71.6562ZM63.7812 105.125C63.7812 106.169 64.1961 107.171 64.9345 107.909C65.6729 108.648 66.6745 109.062 67.7188 109.062H75.5938C76.638 109.062 77.6396 108.648 78.378 107.909C79.1164 107.171 79.5312 106.169 79.5312 105.125V101.434C79.5312 101.368 79.5053 101.306 79.4592 101.26C79.413 101.213 79.3504 101.188 79.2852 101.188H64.0273C63.9621 101.188 63.8995 101.213 63.8533 101.26C63.8072 101.306 63.7812 101.368 63.7812 101.434V105.125Z",
    fill: "#BEDFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2852 79.5312H64.0273C63.8914 79.5312 63.7812 79.6414 63.7812 79.7773V97.0039C63.7812 97.1398 63.8914 97.25 64.0273 97.25H79.2852C79.4211 97.25 79.5312 97.1398 79.5312 97.0039V79.7773C79.5312 79.6414 79.4211 79.5312 79.2852 79.5312Z",
    fill: "#BEDFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.375 109.062H85.4375C84.3932 109.062 83.3917 108.648 82.6533 107.909C81.9148 107.171 81.5 106.169 81.5 105.125V57.875C81.5 56.8307 81.9148 55.8292 82.6533 55.0908C83.3917 54.3523 84.3932 53.9375 85.4375 53.9375H89.375C90.4193 53.9375 91.4208 54.3523 92.1592 55.0908C92.8977 55.8292 93.3125 56.8307 93.3125 57.875V105.125C93.3125 106.169 92.8977 107.171 92.1592 107.909C91.4208 108.648 90.4193 109.062 89.375 109.062ZM111.018 104.811L107.052 62.9753C106.87 61.0496 104.967 59.653 102.803 59.861L98.8841 60.2301C96.7197 60.4356 95.1127 62.1632 95.2948 64.0889L99.2606 105.925C99.4427 107.85 101.345 109.247 103.509 109.039L107.428 108.67C109.593 108.464 111.2 106.737 111.018 104.811Z",
    fill: "#BEDFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_462_10683",
    x: 0,
    y: 0,
    width: 164,
    height: 164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_462_10683"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6,
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_462_10683",
    result: "effect2_dropShadow_462_10683"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_462_10683",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryButton);
export default __webpack_public_path__ + "static/media/LibraryButton.b76a8d9e51289b50851bc92b66644f2c.svg";
export { ForwardRef as ReactComponent };